<template>
  <div class="c_audio_play" v-show="false">
    <!-- Chrome和Safari 浏览器基于安全的策略，已经停止自动播放  必须要你进行和浏览器进行事件互动,人为的点击，触摸等操作才能播放 -->
    <audio preload="preload" controls="controls" ref="concatMusic" id="c-audio-play-concat-music">
      <source :src="concatMusicSrc" type="audio/mpeg"/>
    </audio>

    <audio preload="preload" controls="controls" ref="receiveMsgMusic" id="c-audio-play-receive-msg-music">
      <source :src="receiveMusicSrc" type="audio/mpeg"/>
    </audio>

    <audio preload="preload" controls="controls" ref="sendMsgMusic" id="c-audio-play-send-msg-music">
      <source :src="sendMusicSrc" type="audio/mpeg"/>
    </audio>

  </div>
</template>

<script>

  export default {
    name: 'AudioPlay',
    props: {
      allSliceFlag: {
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return {
        // https://static.meiqia.com/widget/static/new-chat.ogg
        // ttps://static.meiqia.com/widget/static/new-chat.mp3
        concatMusicSrc: '/audio/new-chat.mp3',
        // concatMusicSrc2: '',

        receiveMusicSrc: localStorage.getItem('audio_url') ?? "/audio/msg.mp3",
        // receiveMusicSrc: "/audio/msg2.mp3",
        // receiveMusicSrc: "/audio/new-message.mp3",

        // https://static.meiqia.com/widget/static/sent-message.mp
        sendMusicSrc: '/audio/sent-message.mp3',

        isiOS: false,
      }
    },
    created() {
      var u = navigator.userAgent;
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    methods: {
      // 静音全部播放一次
      sliceAllPlay() {
        // console.log('play')
        this.$global.autoPlayFlag = true

        let concatMusicDom = this.$refs.concatMusic
        concatMusicDom.muted = 'muted' //静音
        concatMusicDom.pause()
        concatMusicDom.currentTime = 0
        concatMusicDom.play()

        let receiveMusicDom = this.$refs.receiveMsgMusic
        receiveMusicDom.muted = 'muted' //静音
        receiveMusicDom.pause()
        receiveMusicDom.currentTime = 0
        receiveMusicDom.play()

        let sendMsgMusicDom = this.$refs.sendMsgMusic
        sendMsgMusicDom.muted = 'muted' //静音
        sendMsgMusicDom.pause()
        sendMsgMusicDom.currentTime = 0
        sendMsgMusicDom.play()
      },

      // 连接的时候播放
      concatPlay() {
        let concatMusicDom = this.$refs.concatMusic
        // // 如果是ios为了解决ios的audio不能直接通过audio.play()播放
        // if(this.isiOS) {
        //   concatMusicDom.load() // iOS 9  还需要额外的 load 一下, 否则直接 play 无效
        //   concatMusicDom.play()
        //   concatMusicDom.pause()
        // }
        // this.concatMusicSrc = 'https://static.meiqia.com/widget/static/new-chat.mp3'
        // concatMusicDom.src = this.concatMusicSrc
        concatMusicDom.muted = '' //开声音
        if(this.allSliceFlag) concatMusicDom.muted = 'muted'
        concatMusicDom.pause()
        concatMusicDom.currentTime = 0
        concatMusicDom.play().catch(() => {})
      },

      changeAudioUrl(audioUrl){
        //切换收到信息的声音
        let receiveMusicDom = this.$refs.receiveMsgMusic
        receiveMusicDom.src = audioUrl;
        receiveMusicDom.load();
        receiveMusicDom.muted = false;
        receiveMusicDom.play().catch(err => {
          console.warn('动态组件切换音频播放受阻:', err.message);
        });
      },

      // 收到消息时播放
      receivePlay() {
        let receiveMusicDom = this.$refs.receiveMsgMusic
        receiveMusicDom.muted = '' //开声音
        if(this.allSliceFlag) receiveMusicDom.muted = 'muted'
        receiveMusicDom.pause()
        receiveMusicDom.currentTime = 0
        receiveMusicDom.play().catch(() => {})
      },

      // 发送消息时播放
      sendMsgPlay() {
        let sendMsgMusicDom = this.$refs.sendMsgMusic
        sendMsgMusicDom.muted = '' //开声音
        if(this.allSliceFlag) sendMsgMusicDom.muted = 'muted'
        sendMsgMusicDom.pause()
        sendMsgMusicDom.currentTime = 0
        sendMsgMusicDom.play().catch(() => {})
      }
    }
  }
</script>

<style lang="scss">
.c_audio_play {
  position: absolute;
  top: 0;
}
</style>